<template>
  <ul class="menu-nav">
    <!-- Regular menu items -->
    <router-link 
      v-for="menu in menuData"
      :key="menu.name"
      :to="{ name: menu.name }"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="hasPermission(menu.permission_scopes) && menu.ifshow && !menu.isDropdown"
    >
      <li
        class="menu-item menu-item-submenu"
        :class="{ 'menu-item-active': isActive || isExactActive }"
      >
        <a class="menu-link" :href="href" @click="navigate">
          <span class="menu-text font-weight-bolder">{{menu.title}}</span>
        </a>
      </li>
    </router-link>

    <!-- Dropdown menu items -->
    <li 
      v-for="menu in menuData"
      :key="menu.name"
      v-if="menu.isDropdown && menu.ifshow && hasPermission(menu.permission_scopes)"
      class="menu-item menu-item-submenu"
    >
      <b-dropdown
        variant="link"
        toggle-class="menu-link text-decoration-none p-0"
        no-caret
        boundary="viewport"
      >
        <template v-slot:button-content>
          <span class="menu-text font-weight-bolder text-dark">{{menu.title}}</span>
          <i class="menu-arrow flaticon2-down"></i>
        </template>

        <b-dropdown-item
          v-for="subItem in menu.subItems"
          :key="subItem.name"
          :to="{ name: subItem.name }"
          link-class="text-dark"
        >
          <span class="font-weight-bold">{{subItem.title}}</span>
        </b-dropdown-item>
      </b-dropdown>
    </li>

    <!-- <router-link
      :to="{ name: 'logs' }"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="false"
    >
      <li
        class="menu-item menu-item-submenu"
        :class="{ 'menu-item-active': isActive || isExactActive }"
      >
        <a class="menu-link" :href="href" @click="navigate">
          <span class="menu-text font-weight-bolder">Logs</span>
        </a>
      </li>
    </router-link>
    <router-link
      :to="{ name: 'analytics' }"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        class="menu-item menu-item-submenu"
        :class="{ 'menu-item-active': isActive || isExactActive }"
      >
        <a class="menu-link" :href="href" @click="navigate">
          <span class="menu-text font-weight-bolder">Analytics</span>
        </a>
      </li>
    </router-link> -->
  </ul>
</template>

<script>
import { PERMISSIONS } from '@/constants';

export default {
  name: "Menu",
  data() {
    return {
      menuData: [
        {
          title: 'Companies',
          name: 'companies',
          ifshow: true,
          isDropdown: false,
          permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        {
          title: 'Logs',
          name: 'logs',
          ifshow: false,
          isDropdown: false,
          permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        {
          title: 'Analytics',
          name: 'analytics',
          ifshow: true,
          isDropdown: false,
          permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        {
          title: 'Platform Stats',
          name: 'platformStats',
          ifshow: true,
          isDropdown: false,
          permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        {
          title: 'Cohort Analysis',
          name: 'cohortAnalysis',
          ifshow: true,
          isDropdown: false,
          permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        {
          title: 'Monthly Numbers',
          name: 'monthlydata',
          ifshow: true,
          isDropdown: false,
          permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        {
          title: 'Financing',
          name: 'financing',
          ifshow: true,
          isDropdown: true,
          permission_scopes: [PERMISSIONS.FINANCING_ALL],
          subItems: [
            {
              title: 'Businesses',
              name: 'financing'
            },
            {
              title: 'Analytics',
              name: 'financing-analytics'
            },
            {
              title: 'Rules',
              name: 'financing-rules'
            },
            {
              title: 'Invoices',
              name: 'financing-invoices'
            },
            {
              title: 'Non-Use Fees',
              name: 'financing-non-use-fees'
            },
            {
              title: 'Late Fees',
              name: 'financing-late-fees'
            }
          ]

        },
        {

          title:'Financial Analyser',
          name:'chatbot',
          ifshow:true,
          permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
      ]
    }
  },
  methods: {
    hasPermission(permissionScopes) {
      if (!permissionScopes || permissionScopes.length === 0) {
        return true;
      }
      
      const userPermissions = this.$store.getters.user?.permissions || [];
      return userPermissions.some(perm => permissionScopes.includes(perm));
    }
  }
};
</script>

<style scoped>
/* Custom styles for dropdown integration */
.menu-nav .dropdown .btn {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  color: inherit !important;
}

.menu-nav .dropdown .btn:focus {
  box-shadow: none !important;
  color: inherit !important;
}

.menu-nav .dropdown .btn:hover {
  background: none !important;
  color: inherit !important;
}

.menu-nav .dropdown .btn:active {
  background: none !important;
  color: inherit !important;
}

.menu-nav .dropdown .btn .menu-text {
  color: #7E8299 !important; /* Match Metronic default text color */
}

.menu-arrow {
  margin-left: 0.5rem;
  font-size: 0.8rem;
  color: #fff !important;
}
</style>
